import type { IconData } from '@stacksjs/iconify-core'

export const contentClipboard: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8 0a3 3 0 0 1 3 3h4v13H1V3h4a3 3 0 0 1 3-3m3 8V6H5v2zm-2 5H5v-2h4z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default contentClipboard
